import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button, Flex, Stack, Title } from '@mantine/core';

import { FieldPropertiesType } from 'store/fields/types';

type Props = {
  clickedFieldFeatureProperties: FieldPropertiesType;
};

const FieldPopupContent = ({ clickedFieldFeatureProperties }: Props) => {
  const { t } = useTranslation();
  return (
    <Stack>
      <Title order={4}>{clickedFieldFeatureProperties.name}</Title>
      <Flex justify="center">
        <Button
          component={Link}
          relative="path"
          to={`../${clickedFieldFeatureProperties.id}`}
          mx="auto"
          size="xs"
        >
          {t('viewEdit')} {t('field')}
        </Button>
      </Flex>
    </Stack>
  );
};

export default FieldPopupContent;
